$(document).on('change', ".ccvp-container > select", function () {
  let selected_option = $(this).children("option:selected");
  let price = selected_option.attr("price");
  let avbl = selected_option.attr("var_avail");
  let variId = selected_option.attr("id");
  let varImage = selected_option.attr("var_image");

  $(this).parent().children(".ccvp-money").html(price);
  $(this).parent().children(".ccvp-button").attr("data-id", variId);
  $(this).parents('.block-inner-inner').find('.image-label-wrap > div > .product-block__image--primary').find('img').attr('srcset', varImage);

  if (avbl == "true") {
    $(this).parent().children(".ccvp-button").html("<span><strong>Add To Cart</strong></span>");
    $(this).parent().children(".ccvp-button").prop("disabled", false);
  } else {
    $(this).parent().children(".ccvp-button").html("<span><strong>Sold Out</strong></span>");
    $(this).parent().children(".ccvp-button").prop("disabled", true);
  }
});

const cartCollectionActions = async () => {
  await clickCartHeader();
};

$(document).on("click", ".ccvp-button", function (event) {
  var _learnq = _learnq || [];
  // script to pass Klaviyo add to cart event
  let item = {
    "Name": $(this).attr('data-name'),
    "ProductID": $(this).attr('data-id')
  }
  _learnq.push(['track', 'Added to Cart', item]);
  // script to pass Klaviyo add to cart event
  event.preventDefault();
  let sPlan = $(this).attr("data-plan");
  let variID2 = $(this).attr("data-id");
  
  const dataNote = {
    "Note": $(this).attr("data-note")
  }
  
  addItemToCart(variID2, "1", sPlan, dataNote);
  cartCollectionActions();
});
